<template>
  <div>
    <CRow v-for="objs in idpLocal" :key="objs.id" >
      <CCol col="12" >
        <CCard class="bg-style2 mb-2" :class="border(objs)">
          <CCardHeader  class="text-white" :class="backgorund(objs)" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <label class="font-weight-bold mt-1">  {{ objs.title.filter(item => { return (item.key === lang)})[0].value.toUpperCase() }} </label>

            <div class="card-header-actions" v-if="isTalentLocal">
              <CButton  class="ml-2 " size="sm" color="light" shape="pill" variant="outline"  v-c-tooltip.hover.click="$t('remove')" @click="onRemove(objs)">
                <span class="font-weight-bold "><CIcon name="cil-trash" /></span>
              </CButton>
            </div>
          </CCardHeader>
          <CCardBody >
            <CRow>
              <CCol col="12" v-if="objs.description.length > 0" @click="toggleDetails(objs)">
                <div v-html="objs.description.filter(item => { return (item.key === lang)})[0].value"></div>
              </CCol>
            </CRow>

<!--            {{objs.levels}}-->

            <CRow v-for="objsLevel in objs.levels" :key="objs.id" >
<!--              <CRow v-for="objsLevel in objs.levels" :key="objs.id"  @click="toggleDetails(objs)">-->
<!--              {{ objs }}-->
              <CCol  col="12">
                <CDropdownDivider/>
              </CCol>

<!--              {{objsLevel}}-->
              <CCol col="12" >
                <label class="font-weight-bold mt-1 h6">
                  <CIcon name="cil-tags" class="mr-2"/> {{ objsLevel.title.filter(item => { return (item.key === lang)})[0].value }}
                </label>
              </CCol>

              <CCol col="12"  v-for="item in objsLevel.item" :key="item.id" >
                <CRow>
                  <CCol  col="12" >
                    <label class="pl-2 pr-2" >  {{ item.title.filter(item => { return (item.key === lang)})[0].value }} </label>
                  </CCol>
                </CRow>
              </CCol>

              <CCol  col="12">
                <CDropdownDivider/>
              </CCol>

              <CCol col="12">
                <CCollapse :show="Boolean(!objs._toggled)" :duration="collapseDuration">
                  <CRow >
                    <CCol col="12" v-for="(item, index) in objsLevel.method" :key="item.id">
                      <CCard  >
                        <CCardBody class="pb-0">
                            <IDPFrom class="mt-2" @remove="onRemove" :objs="item" :option="option" :disabled="isMethod.disabled" :levels="parseInt(objsLevel.title[0].value.match(/\d+/))" :cc="parseInt(objs.title[0].value.split('-')[0].match(/\d+/)[0])"/>
                        </CCardBody>
                      </CCard>
                    </CCol>
                  </CRow>
                  <IDPResults  v-if="isResults.state" :control="isResults"  :caption="$t('idp.results')" :content="objsLevel.results" :cc="index"/>

                  <CRow v-if="isCreated" class="mb-4" >
                    <CCol class="text-right">
                      <CButton v-if="objsLevel.method.length > 1"  class="ml-2 " size="sm" color="danger" shape="pill" variant="outline" @click="onRemoveMethod(objsLevel.method)">
                        <span class="font-weight-bold "><CIcon name="cil-minus" /></span>
                      </CButton>
                      <CButton  v-if="objsLevel.method.length < limitMethod" class="ml-2 " size="sm" color="success" shape="pill" variant="outline" @click="onAddMethod(objsLevel.method)">
                        <span class="font-weight-bold "><CIcon name="cil-plus" /></span>
                      </CButton>
                    </CCol>
                  </CRow>
                </CCollapse>
              </CCol>
            </CRow>


          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import IDPFrom from "@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDPFrom.vue";
import IDPResults from "@/projects/views/E-Performances/IndividualDevelopmentPlan/components/IDPResults.vue";
import RequiredValidation from "@/projects/mixins/requiredValidation";

export default {
  name: 'IDPInfomation',
  components: {IDPResults, IDPFrom},
  mixins: [RequiredValidation],
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    index: {
      type: Number,
      default:0
    },
    idp: {
      type: Object/Array,
      default() {
        return null
      }
    },
    isCreated: {
      type: Boolean,
      default() {
        return false
      }
    },
    isTalent: {
      type: Boolean,
      default() {
        return false
      }
    },
    option: {
      type: Object,
      // required: true, // ถ้าจำเป็นต้องมี
      default() {
        return {
          course: [],
          method: [],
          faculty: [],
        }
      }
    },
  },

  data: function () {
    return {
      limitMethod : 3,
      collapseDuration: 0,
      isTalentLocal: this.isTalent,
      idpLocal: Array.isArray(this.idp) ? this.idp.slice() : [],

      // method : [{id:1}]

      isMethod : {
        disabled: false,
      },
      isResults : {
        state : false,
        disabled: true,
        button : false,
        step:3
      },
    }
  },

  mounted() {
  },

  created() {
    this.isStateView();

  },

  beforeDestroy() {
  },

  methods: {
    getProfileIds() {
      const profile = this.$store.getters["personal/profile"] || {};
      return [profile._id, profile.accounts?._id].filter(Boolean);
    },

    isOwnerUser() {
      const ownerIds = [
        this.$store.getters["idp/idp"]?.accounts?._id,
        this.$store.getters["idp/idp"]?.accounts?.accounts?._id
      ].filter(Boolean);

      return ownerIds.some((id) => this.getProfileIds().includes(id));
    },

    isAssessorUser() {
      const assessorIds = [
        this.$store.getters["idp/idp"]?.assessor?.accounts?._id,
        this.$store.getters["idp/idp"]?.assessor?.accounts?.accounts?._id
      ].filter(Boolean);

      return assessorIds.some((id) => this.getProfileIds().includes(id));
    },

    getCurrentStatusId() {
      return this.$store.getters["idp/idp"]?.status?.at?.(-1)?.state?._id || null;
    },

    getPreviousStatusId() {
      return this.$store.getters["idp/idp"]?.status?.at?.(-2)?.state?._id || null;
    },

    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    onRemove(value) {
      if (Array.isArray(this.idpLocal) && this.idpLocal.length > 1) {
        this.idpLocal = this.idpLocal.filter(item => item._id.toString() !== value._id.toString());
      }

      this.$emit('update', this.idpLocal, this.index)
    },

    border(value){
      // var isVerification = value.method.filter(item => { return item.verification.status === false})
      // if(this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d'){
      //   if(isVerification.length > 0 ){
      //     return 'border-danger'
      //   }else{
      //     return 'border-success'
      //   }
      // }else{
        return 'border-dark'
      // }
    },

    backgorund(value){
      // var isVerification = value.method.filter(item => { return item.verification.at(-1).status === false})
      // if(this.$store.getters['idp/idp'].status.at(-1).state._id === "6723709ab9a2030e40d1b884"){
      //   if(isVerification.length > 0 ){
      //     return 'bg-gradient-danger'
      //   }else{
      //     return 'bg-gradient-success'
      //   }
      //
      //
      // }else if(this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d'){
      //   if(isVerification.length > 0 ){
      //     return 'bg-gradient-danger'
      //   }else{
      //     return 'bg-gradient-success'
      //   }
      // }else{
        return 'bg-gradient-dark'
      // }
    },
    checkState(value){
      if(this.$store.getters['idp/idp'].status.at(-1).state._id === "6723709ab9a2030e40d1b884"){
        var isVerification = value.method.filter(item => { return item.verification.status === false})
        if(isVerification.length > 0 ){
            return 'bg-gradient-danger'
          }else{
            return 'bg-gradient-success'
          }


      }else if(this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d'){
        // if(value.results.status === true){
        //   return 'bg-gradient-success'
        // }else{
        //   return 'bg-gradient-danger'
        // }
      }else{
        return 'bg-gradient-dark'
      }
    },

    checkState1(value){

      var objs = this.$store.getters["idp/idp"].status.at(-1)
      var previousStatusId = this.getPreviousStatusId()

      switch (objs.state._id) {
        case "654851a37ab25be71bbeeed6": // Pending
          return 'dark';
        case "654851dbe41b7f46025977f6": // Save
          return 'dark';
        case "654851ece41b7f46025977fa": // Send
          return 'dark';
        default:
          if(value.verification.status === true){
            return 'success'
          }else{
            return 'dark'
          }
          // break;

      }
      // if(this.$store.getters['idp/idp'].status.at(-1).state._id === "6723709ab9a2030e40d1b884"){
      //   if(value.verification.status === true){
      //     return 'success'
      //   }else{
      //     return 'danger'
      //   }
      //
      // //
      // //
      // // }else if(this.$store.getters['idp/idp'].status.at(-1).state._id === '67bfc7ed24e13ba338b58e4d'){
      //   // if(value.status === true){
      //   //   return 'success'
      //   // }else{
      //   //   return 'danger'
      //   // }
      // }else{
      //   return 'dark'
      // }
    },



    // management new
    onRemoveMethod(method){
      if(method.length > 1){
        method.pop()
      }
    },
    onAddMethod(method){
      if(method.length < this.limitMethod){
        var objs = {
          verification: [{ comment: "", status: false }],
          code: null,
          course: null,
          developments : [],
          results : [],
          status: false,
        };

        method.push(objs)
      }

    },




    isStateView(){
      // this.isVerification = false;
      // this.isLearnedDeveloper = false;
      // this.isResults = false;
      var objs = this.$store.getters["idp/idp"].status.at(-1)
      var previousStatusId = this.getPreviousStatusId()

      if (!objs || !objs.state || !objs.state._id) {
        return;
      }

      this.isTalentLocal = false;
      this.isMethod = {
        disabled: true,
      };
      this.isResults = {
        state : false,
        disabled: true,
        button : false,
        step:3
      };

      if(this.isOwnerUser()) {
        this.isTalentLocal = this.$store.getters["idp/idp"].isTalent;
      }

      switch (objs.state._id) {

        case "654851a37ab25be71bbeeed6": // Pending
          this.isMethod = {
            disabled: !this.isOwnerUser(),
          }
          break;
        case "654851dbe41b7f46025977f6": // Save
          this.isMethod = {
            disabled: !this.isOwnerUser(),
          }
          break;
        case "670f777373effdb76e17954d": // unsend
          if (
            previousStatusId === "67bc35d9ac0179614e274a67" ||
            previousStatusId === "67bfc7e724e13ba338b58e47"
          ) {
            this.isMethod = {
              disabled: true,
            }
          } else {
            this.isMethod = {
              disabled: !this.isOwnerUser(),
            }
          }
          break;
        case "654851ece41b7f46025977fa": // Send
        case "67bc20d5ef3c015b73cf6dbc": // Verification
        case "67bc35d9ac0179614e274a67": // development
          this.isMethod = {
            disabled: true,
          }
          break;
        case "6723709ab9a2030e40d1b884": // Reject
          this.isMethod = {
            disabled: !this.isOwnerUser(),
          }
          break;
        case "67bfc7e724e13ba338b58e47": // result in development
          this.isMethod = {
            disabled: true,
          }
          if(this.isOwnerUser()){
            this.isResults = {
              state : true,
              disabled: true,
              button : false,
              step:3
            }
          }

          if(this.isAssessorUser()){
            this.isResults = {
              state : true,
              disabled: false,
              button : true,
              step:3
            }
          }

          break;

        case "67bfc7ed24e13ba338b58e4d": // complete

          this.isTalentLocal = false;
          this.isMethod = {
            disabled: true,
          }
          this.isVerification = {
            state : true,
            disabled: true,
            button : false,
            step :1
          }
          this.isLearnedDeveloper = {
            state : true,
            disabled: true,
            button : false,
            step:2
          }
          this.isResults = {
            state : true,
            disabled: true,
            button : false,
            step:3
          }
          break;

        default:
          this.isMethod = {
            disabled: true,
          }
          break;

      }
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      method: "idp/method",
      course: "idp/course",
      currentIdp: "idp/idp"
    })
  },

  watch: {
    lang(value){

      var lang = this.$store.getters['setting/lang']
      var data = {};
      data.label = "-"
      data.value = "000000000000000000000000"
      this.option.method = [data, ...this.$store.getters['idp/method'].map(objs => ({
        label: objs.title.filter(title => {
          if (title.key === lang) {
            return title
          }
        })[0].value,
        value: objs._id,
        developments : objs.developments.filter(item => {
          if(item.style === 2){
            item.value = "";
          }
          return item
        }),
        results : objs.results.filter(item => {
          if(item.style === 2){
            item.value = "";
          }
          return item
        }),
        control : objs.control
      }))];
    },

    method: function (value) {
      var lang = this.$store.getters['setting/lang'];
      // var data = {};
      // data.label = "-";
      // data.value = "000000000000000000000000";
      this.option.method = [ ...value.map(objs => ({
        label: objs.title.filter(title => {
          if (title.key === lang) {
            return title
          }
        })[0].value,
        value: objs._id,
        code:objs.code,
        developments : objs.developments.filter(item => {
          if(item.style === 2){
            item.value = "";
          }
          return item
        }),
        results : objs.results.filter(item => {
          if(item.style === 2){
            item.value = "";
          }
          return item
        }),
        control : objs.control

      }))];
    },

    course: function (value) {
      var lang = this.$store.getters['setting/lang'];
      // var data = {};
      // data.label = "-";
      // data.value = "000000000000000000000000";
      this.option.course = [ ...value.map(objs => ({
        label: objs.title.filter(title => {
          if (title.key === lang) {
            return title
          }
        })[0].value,
        value: objs._id,
      }))];
    },
    currentIdp: {
      deep: true,
      handler() {
        this.isStateView()
      }
    },
        idp: function (newVal) {
          this.idpLocal = Array.isArray(newVal) ? newVal.slice() : [];
        },
    isTalent: function (newVal) {
      this.isTalentLocal = newVal
    }
  }
}
</script>
<style>

</style>
